import { APICore } from './apiCore';

const api = new APICore();

export interface AppVersionDetails {
    os: 'android' | 'ios';
    latestVersion: string;
    mandatoryUpdate?: boolean;
    androidUpdateType?: 'FLEXIBLE' | 'IMMEDIATE' | null;
    appLinkUrl?: string | null;
    isActive?: boolean;
}

export interface UpdateAppVersionDetails {
    latestVersion?: string;
    mandatoryUpdate?: boolean;
    androidUpdateType?: 'FLEXIBLE' | 'IMMEDIATE' | null;
    appLinkUrl?: string | null;
    isActive?: boolean;
}

// GET /admin/app-versions
function getAppVersions() {
    return api.get('/admin/app-versions', {});
}

// GET /admin/app-versions/:id
function getAppVersionById(params: { id: number }) {
    return api.get(`/admin/app-versions/${params.id}`, {});
}

// POST /admin/app-versions (upsert by OS)
function createAppVersion(params: { data: AppVersionDetails }) {
    return api.create('/admin/app-versions', params.data);
}

// PUT /admin/app-versions/:id
function updateAppVersion(params: { id: number; data: UpdateAppVersionDetails }) {
    return api.update(`/admin/app-versions/${params.id}`, params.data);
}

// DELETE /admin/app-versions/:id
function deleteAppVersion(params: { id: number }) {
    return api.delete(`/admin/app-versions/${params.id}`);
}

export {
    getAppVersions,
    getAppVersionById,
    createAppVersion,
    updateAppVersion,
    deleteAppVersion,
};
